import { BUSINESS } from "@/lib/business";
import { PhoneButton } from "./PhoneButton";

export function CTABand({ title }: { title?: string }) {
  return (
    <section className="bg-primary text-primary-foreground">
      <div className="mx-auto max-w-7xl px-4 py-10 md:py-14 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
        <div>
          <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight">
            {title ?? "Need plumbing help in Phoenix?"}
          </h2>
          <p className="opacity-90 mt-1">
            Call Phoenix Plumbing Co. at {BUSINESS.phone} or request service online.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <PhoneButton variant="secondary" size="lg" label={`Call ${BUSINESS.phone}`} />
          <a href="#quote" className="inline-flex items-center justify-center rounded-md border-2 border-primary-foreground bg-transparent px-7 py-4 text-lg font-extrabold text-primary-foreground hover:bg-primary-foreground/10">
            Request Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}